import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../login/login.service';
import { ReporteService } from '../reporte.service';
import Swal from 'sweetalert2';
declare const require: any;

import { PeriodoEjercicioService } from '../../../control/periodo.service';
const jsPDF = require('jspdf');
@Component({
  templateUrl: './reporte-balance-general.component.html',
  styleUrls: ['./reporte-balance-general.component.css'],
  preserveWhitespaces: true,
  providers: [ReporteService]
})
export class ReporteBalanceGeneralComponent implements OnInit {
  public reporte: any[] = [];
  public list: any[] = [];
  public saldoCero: boolean;
  public ano: number;
  public mes: number;
  public anos: any[] = [];
  cargado: boolean;
  public meses: any[] = [
  {numero: 1 , nombre: 'enero'},
  {numero: 2, nombre: 'febrero'},
  {numero: 3, nombre: 'marzo'},
  {numero: 4, nombre: 'abril'},
  {numero: 5, nombre: 'mayo'},
  {numero: 6, nombre: 'junio'},
  {numero: 7, nombre: 'julio'},
  {numero: 8, nombre: 'agosto'},
  {numero: 9, nombre: 'septiembre'},
  {numero: 10, nombre: 'octubre'},
  {numero: 11, nombre: 'noviembre'},
  {numero: 12, nombre: 'diciembre'},
  {numero: 13, nombre: 'periodo_ajuste'}];
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(private loginService: LoginService,
    private reporteService: ReporteService, private PeriodoEjercicioService: PeriodoEjercicioService) { }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit() {
    this.PeriodoEjercicioService.periodo$
      .subscribe(periodo => {

        this.mes = periodo ? periodo : 13;
      });
    this.cargarAnos();
  }
  toogle() {
    if (this.saldoCero === false) {
      this.saldoCero = true;
    } else {
      this.saldoCero = false;
    }
  }
  cargarAnos() {
    const ejercicios = JSON.parse(localStorage.getItem('ejercicios'));
    for (let x = 0; x < ejercicios.length; x++) {
      this.anos.push(ejercicios[x].anio);
    }
    
    this.saldoCero = true;
             this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.ano = ejercicio ? ejercicio : 0;

    });
    this.cargarReporte();
  }
  cargarReporte() {
    this.mostrarMensajeCarga('Se está generando tu reporte');
    this.reporteService.getRepBalGen(this.loginService.empresa, this.mes, this.ano).subscribe(
      response => {
        this.reporte = response.contenido;
        for (const item of this.reporte) {
          for (const item2 of item) {
            this.list.push(item2);
          }
        }
        this.cerrarMensajeCarga();
      }, err => {
        this.cerrarMensajeCarga();
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
      });
  }
  exportAsPDF() {
    if (this.list.length === 0) {
      Swal.fire('Aviso', 'La tabla no contiene datos el cual exportar a un archivo PDF', 'warning');
    } else {
      this.reporteService.getRepBalGenPdf(this.loginService.empresa, this.mes, this.ano).subscribe(
        response => {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(response);
          a.download = 'Balance_general_' + (this.mes==13?'periodo_ajuste':this.meses[this.mes-1].nombre) + '_' + this.ano + '.pdf';
          document.body.appendChild(a);
          a.click();
        }
      );
    }
  }
  exportAsXLSX() {
    if (this.list.length === 0) {
      Swal.fire('Aviso', 'La tabla no contiene datos el cual exportar a un archivo XLSX', 'warning');
    } else {
      this.reporteService.getRepBalGenXlsx(this.loginService.empresa, this.mes, this.ano).subscribe(
        response => {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(response);
          a.download = 'Balance_general_' + (this.mes==13?'periodo_ajuste':this.meses[this.mes-1].nombre) + '_' + this.ano + '.xls';
          document.body.appendChild(a);
          a.click();
        }
      );
    }
  }

  mostrarMensajeCarga(mensaje: string) {
    this.cargado = false;
    const numeros = [1, 2, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6];
    const aleatorio = numeros[Math.floor(Math.random() * numeros.length)];
    Swal.fire({
      html: `
      <div style="text-align: center">
        <h4><img src="/assets/gif/loading` + aleatorio + `.gif" width="80"/>
        <br><br><strong>Por favor espere...</strong><br><small>` + mensaje + `</small></h4>
      </div>`,
      toast: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
